import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { AIRMETS_LEGEND } from './airmets.legend';
import { AIRMETS_PRODUCT_DATA } from './airmets.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class AirmetsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(AIRMETS_PRODUCT_DATA, {
    legend: AIRMETS_LEGEND,
    twcLayerTypes: ['vector-tile']
  });
}
